import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const LanguageContext = createContext();

export const useLanguage = () => {
  return useContext(LanguageContext);
};

export const LanguageProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  const intcount = process.env.GATSBY_DB_SERVER;
  const cyclicServerToken = process.env.GATSBY_SERVER_TOKEN;

  useEffect(() => {
    fetchSelectedLanguage();
  }, []);

  const fetchSelectedLanguage = async () => {
    try {
      const response = await axios.get(`${intcount}/selectedLanguage`, {
        headers: {
          Authorization: `Bearer ${cyclicServerToken}`,
        },
      });
      setSelectedLanguage(response.data.selectedLanguage);
    } catch (error) {
      console.error('Error fetching selected language:', error);
    }
  };

  const changeLanguage = async (language) => {
    setSelectedLanguage(language);
    try {
      await axios.post(
        `${intcount}/selectedLanguage`,
        { selectedLanguage: language },
        {
          headers: {
            Authorization: `Bearer ${cyclicServerToken}`,
          },
        }
      );
    } catch (error) {
      console.error('Error storing selected language:', error);
    }
  };

  const value = {
    selectedLanguage,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
